import Swal from "sweetalert2";
import React, { useEffect, useState, useMemo } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { updatePrescriptionType } from "../Redux/Slice/rootSlice";
import { SelectPicker, Stack } from "rsuite";

function PrescriptionType_PopUp(props) {
  const navigate = useNavigate();
  const [selectedType, setSelectedType] = useState("");

  const dispatch = useDispatch();
  const closeUserPopup = (e) => {
    props.setTypePrescriptionPopUp(false);
  };
  const handleDropChanges = (e) => {
    // console.log(e, "mmmm");
    setSelectedType(e);
  };
  const handleSubmit = () => {
    dispatch(updatePrescriptionType(selectedType));
    navigate("/prescription");
  };
  const data = [
    "First Trimester",
    "RPL Report",
    "RIL Report",
    "CBG Report",
    "Delivery Admission Form",
    "DeliveryEssentials",
    "Drug Chart",
    "Follicular Monitoring",
    "HRT",
    "Month Wise Review Ivf",
    "Month Wise Review Spontaneous Conception",
    "NT SCAN IVF",
    "NT Spontaneous",
    "Post Natal",
    "White discharge Template Date",
  ].map((item) => ({ label: item, value: item }));
  return (
    <>
      <div className="adminform" style={{ alignItems: "start" }}>
        <div class="modal-dialog1" role="document">
          <div class="modal-content modelContentChanges">
            <div class="modal-header">
              <h5 class="modal-title">Prescription</h5>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={(e) => closeUserPopup(e)}
              >
                <i class="bi bi-x-lg"></i>
              </button>
            </div>
            <div
              class="modal-body modelBodyChanges"
              style={{ padding: "1rem", width: "520px" }}
            >
              <div className="row">
                <div className="col-12">
                  <p>Select type of prescription</p>
                </div>
                <div class="col-12 title-dropdown">
                  {/* <select
                    id="type"
                    name="type"
                    value={selectedType}
                    onChange={(e) => handleDropChanges(e)}
                    className="form-select"
                  >
                    <option value="" disabled selected>
                      Select type of prescription
                    </option>
                    <option value="First Trimester">First Trimester</option>
                    <option value="RPL Report">RPL Report</option>
                    <option value="RIL Report">RIL Report</option>
                    <option value="CBG Report">CBG Report</option>
                    <option value="Delivery Admission Form">Delivery Admission Form</option>
                    <option value="DeliveryEssentials">DeliveryEssentials</option>
                  </select> */}
                  <Stack
                    spacing={10}
                    direction="column"
                    alignItems="flex-start"
                  >
                    <SelectPicker
                      data={data}
                      style={{ width: 300 }}
                      onChange={(e) => handleDropChanges(e)}
                    />
                  </Stack>

                  {/* {error && createUserInfo.titles == "" && (
                    <p style={{ fontSize: "12px", color: "red" }}>
                      <span>Required Title</span>
                    </p>
                  )} */}
                </div>
              </div>
            </div>
            <div
              class="modal-footer modelBodyChanges"
              style={{ padding: "1rem", width: "520px" }}
            >
              <button
                onClick={handleSubmit}
                className="submitPrescriptionTypebtn"
                disabled={selectedType !== "" ? false : true}
              >
                Select
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default PrescriptionType_PopUp;
